export const iconFontAwesomeTransportationTrainTram = (
	<i className="fa-solid fa-train-tram"></i>
);
